module.exports = __webpack_public_path__ + "media/icons/lock@3x-aef55e07.svg";